import { Injectable } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { OperatorLoginComponent } from "../operator-login.component";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Injectable()
export class OperatorLoginModal {
	constructor(
		private modalController: ModalController,
		private rideOpsUi: RideOpsUiService,
	) {}

	async show(selectedOperator: Operator): Promise<Operator> {
		const modal = await this.modalController.create({
			component: OperatorLoginComponent,
			id: "operator-login-modal",
			cssClass: this.rideOpsUi.isV2Active() ? "operator-login-modal-v2" : undefined,
			componentProps: {
				operator: selectedOperator,
			},
		});

		await modal.present();

		const value = await modal.onDidDismiss();
		return value?.data?.operator;
	}
}
